import { render, staticRenderFns } from "./CurrencyText.vue?vue&type=template&id=f8ed26f6&class=currency-text-component%20c-text-c"
import script from "./CurrencyText.vue?vue&type=script&lang=js"
export * from "./CurrencyText.vue?vue&type=script&lang=js"
import style0 from "./CurrencyText.vue?vue&type=style&index=0&id=f8ed26f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports